export const SWITCH_AUTH = 'AUTH/SWITCH_AUTH';
export const AUTH_REGISTER = 'AUTH/REGISTER';
export const AUTH_LOGIN = 'AUTH/LOGIN';
export const AUTH_CHECK = 'AUTH/CHECK';
export const AUTH_CHECK_FAIL = 'AUTH/CHECK_FAIL';
export const AUTH_DONE = 'AUTH/AUTH_DONE';
export const AUTH_USER_VERIFIED = 'AUTH/AUTH_USER_VERIFIED';

export const SET_ALERT = 'ALERT/SET_ALERT';
export const REMOVE_ALERT = 'ALERT/REMOVE_ALERT';

export const LOADING_TRUE = 'LOADING/LOADING_TRUE';
export const LOADING_FALSE = 'LOADING/LOADING_FALSE';

export const MODAL_VERIFICATION_OPEN = 'MODAL/MODAL_VERIFICATION_OPEN';
export const MODAL_VERIFICATION_CLOSE = 'MODAL/MODAL_VERIFICATION_CLOSE';

export const ROOM_MODAL_OPEN = 'CHAT/ROOM_MODAL_OPEN';
export const ROOM_MODAL_CLOSE = 'CHAT/ROOM_MODAL_CLOSE';
export const JOIN_ROOM = 'CHAT/JOIN_ROOM';
export const CREATE_NEW_ROOM = 'CHAT/CREATE_NEW_ROOM';
export const CHOSEN_ROOM = 'CHAT/CHOSEN_ROOM';
export const LOAD_MESSAGES = 'CHAT/LOAD_MESSAGES';
export const NEW_LAST_MESSAGE = 'CHAT/NEW_LAST_MESSAGE';